export default "__VITE_ASSET__lSexo24___"